import { useState } from 'react';
import cn from 'classnames';

import { IDetailsItem } from './KnmEpguNotification';
import styles from './DetailItem.module.scss';

interface IDetailItemProps {
  detailItem: IDetailsItem;
}

export const DetailItem = ({ detailItem }: IDetailItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const isHasChild = detailItem.items && detailItem.items.length > 0;

  if (!detailItem.value) {
    if (!detailItem.items) {
      return null;
    }

    return (
      <>
        {detailItem.items.map(item => (
          <DetailItem detailItem={item} key={item.field} />
        ))}
      </>
    );
  }

  return (
    <div className={styles.Content}>
      {isHasChild && (
        <svg
          className={cn(styles.Icon, { [styles.IconOpened]: isOpen })}
          onClick={handleClick}
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="Vector"
            d="M1 13L7 7L1 1"
            stroke="#999999"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <div className={cn(styles.Value, { [styles.Pointer]: isHasChild })} onClick={handleClick}>
        {detailItem.value}
      </div>
      {isOpen && detailItem.items?.map((item, index) => <DetailItem detailItem={item} key={index} />)}
    </div>
  );
};
